export enum CostPriceModel {
  MOVINGAVERAGE = '0',
  LASTRECEIPTPRICE = '1'
}

export const costPriceModelTranslationMap = {
  [CostPriceModel.MOVINGAVERAGE]: 'costPriceModels.movingAverage',
  [CostPriceModel.LASTRECEIPTPRICE]: 'costPriceModels.lastReceiptPrice',
};